// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:48:25.245Z
// Property: Confluence at Harvest Hills (ID: 6767906449167191)
// Collections: 15 amenities, 6 floorplans (live), 13 photos, 71 POIs, 5 reviews, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167191",
  "property_external_id": "1019876",
  "property_zillow_url": "https://www.zillow.com/apartments/williston-nd/confluence-at-harvest-hills/5YCvD3/",
  "property_apartments_url": "https://www.apartments.com/confluence-at-harvest-hills-williston-nd/rtt20h3/",
  "property_google_business_url": "https://www.google.com/maps/place/Confluence+At+Harvest+Hills/data=!4m2!3m1!1s0x0:0xe18fb52dd4a2d854?sa=X&ved=2ahUKEwj_zMC99IOTAxWOTjABHWyCDJ8Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47755006836",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "confluence-at-harvest-hills",
  "property_name": "Confluence at Harvest Hills",
  "property_website_url": "https://www.confluenceapartments.com",
  "property_domain": "https://www.confluenceapartments.com",
  "property_address": "3701 Prairie Commons St",
  "property_full_address": "3701 Prairie Commons St, Williston, ND 58801",
  "property_address_1": "3701 Prairie Commons St",
  "property_address_2": null,
  "property_address_city": "Williston",
  "property_address_state": "ND",
  "property_address_zip_full": "58801",
  "property_address_zip": "58801",
  "property_address_country": "US",
  "property_address_county": "Williams County",
  "property_neighborhood_address": "North Dakota Area",
  "property_address_latitude": "48.17231719999999",
  "property_address_longitude": "-103.6785911",
  "property_email": "confluence@weidner.com",
  "property_phone": "(701) 204-6936",
  "property_call_tracking_phone": "701-204-6936",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in Williston, ND, Confluence at Harvest Hills offers beautifully designed one, two, and three-bedroom apartments. Enjoy abundant natural light through large windows, unwind on your patio or balcony, and take advantage of our outdoor BBQ grilling area. Experience modern living with energy-efficient appliances and ample closet space. Your ideal home awaits!",
  "property_long_description": "Welcome to Confluence at Harvest Hills, your perfect home in the heart of Williston, ND! Our vibrant apartment community offers a variety of spacious floor plans to suit your lifestyle, including one, two, and three-bedroom options designed for comfort and convenience. Each apartment is thoughtfully equipped with energy-efficient appliances, large closets, and a cozy patio or balcony, perfect for enjoying the beautiful North Dakota sunsets.\n\nAt Confluence at Harvest Hills, we take pride in our exceptional amenities. Enjoy outdoor living in our BBQ grilling area, ideal for summer gatherings with friends and family. For your peace of mind, our on-site management and 24-hour emergency maintenance team ensure that your needs are met promptly. With ample on-site parking and convenient pet stations, living here truly feels like home.\n\nOur thoughtfully designed units feature roomy cabinets, deep double sinks, and convenient breakfast bars, making daily living a breeze. Choose from furnished options to make your move seamless. Plus, our smoke-free community promotes a healthy and enjoyable environment for all residents.\n\nDon't miss the chance to experience the best of apartment living at Confluence at Harvest Hills. Explore our available floor plans and discover why our residents love calling this place home. Find your new home today – browse our availability or schedule a tour to visit our community! Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-8d5b-71fb-af65-94c9c1fdfdc3.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and kitchen area with bar seating",
    "public_id": "019d021e-8d5b-71fb-af65-94c9c1fdfdc3",
    "storage_key": "property/6767906449167191/019d021e-8d5b-71fb-af65-94c9c1fdfdc3.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "54",
  "property_year_built": "2012",
  "property_year_renovated": null,
  "property_walk_score": "2",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "87.03703703703704",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: Varies",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://confluenceapartments.securecafe.com/onlineleasing/confluence-at-harvest-hills/floorplans.aspx",
  "property_resident_portal_url": "https://confluenceapartments.securecafenet.com/residentservices/confluence-at-harvest-hills/userlogin",
  "property_apply_now_url": "https://confluenceapartments.securecafe.com/onlineleasing/confluence-at-harvest-hills/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-c278-700a-afd5-b04ad56235df.webp",
  "property_primary_logo_media": {
    "alt_text": "Confluence at Harvest Hills apartment homes logo",
    "public_id": "019d021e-c278-700a-afd5-b04ad56235df",
    "storage_key": "property/6767906449167191/019d021e-c278-700a-afd5-b04ad56235df.webp",
    "width": 1443,
    "height": 548
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-de05-728b-ad0c-44d9fd486b39.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Confluence at Harvest Hills Apartment Homes logo",
    "public_id": "019d021e-de05-728b-ad0c-44d9fd486b39",
    "storage_key": "property/6767906449167191/019d021e-de05-728b-ad0c-44d9fd486b39.webp",
    "width": 1443,
    "height": 548
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d0220-8efe-70d4-9531-26ac2f6e0595.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Confluence at Harvest Hills Apartment Homes logo",
    "public_id": "019d0220-8efe-70d4-9531-26ac2f6e0595",
    "storage_key": "property/6767906449167191/019d0220-8efe-70d4-9531-26ac2f6e0595.webp",
    "width": 640,
    "height": 243
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#1A4C40",
  "property_secondary_color": "#C5D3ED",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#417F92",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "953 - 1098",
  "property_sqft_min": "635",
  "property_sqft_max": "1275",
  "property_price_range": "1110 - 1400",
  "property_price_min": "1110",
  "property_price_max": "1400",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/ConfluenceAtHarvestHillsApartments",
  "property_instagram_url": "https://www.instagram.com/confluenceatharvesthills/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJbUSmjEVZIVMRVNii1C21j-E",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Confluence at Harvest Hills",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Confluence at Harvest Hills, where comfort meets style in the heart of Williston, ND. Choose from thoughtfully designed one, two, or three-bedroom apartments, featuring spacious layouts, modern amenities, and energy-efficient appliances. Enjoy outdoor BBQs, ample parking, and a smoke-free environment—your serene oasis awaits!",
  "property_home_floorplans_blurb": "Welcome to Confluence at Harvest Hills in Williston, ND, where modern living meets scenic beauty. Our thoughtfully designed floor plans cater to your lifestyle, offering comfort and convenience in a vibrant community. Browse our available apartment homes, and envision the perfect space to call your own!",
  "property_home_gallery_blurb": "Welcome to Confluence at Harvest Hills in Williston, ND, where spacious living meets modern comfort! Choose from our inviting one, two, or three-bedroom floor plans, complete with energy-efficient appliances, large closets, and private patios. Enjoy outdoor grilling, 24-hour emergency maintenance, and pet-friendly amenities. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Confluence at Harvest Hills, ideally situated in Williston, ND. Immerse yourself in local culture by visiting the Williston Community Library, the Frontier Museum, or enjoying a game at Ardean Aafedt Stadium. With one, two, and three-bedroom floor plans, your perfect home awaits in a vibrant neighborhood. ",
  "property_home_reviews_blurb": "At Confluence at Harvest Hills in Williston, ND, residents rave about the welcoming atmosphere and stunning amenities. One resident exclaimed, \"Living here feels like home!\" Experience the charm and comfort that our community offers. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Confluence at Harvest Hills, vibrant community life thrives in Williston, ND. Your new home is surrounded by treasures—discover the Western Star Complex, Ardean Aafedt Stadium, and Williston State College. Embrace entertainment, education, and culture, all just steps from your door. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Confluence at Harvest Hills in Williston, ND, comfort meets style. With spacious one, two, and three-bedroom layouts, you’ll love our pet-friendly community. Enjoy outdoor BBQs, large windows, energy-efficient appliances, and features like convenient breakfast bars and deep double sinks. Experience elevated living in a smoke-free environment.",
  "property_applynow_blurb": "At Confluence at Harvest Hills in Williston, ND, experience the perfect blend of comfort and style. Choose from spacious one, two, or three-bedroom floor plans, all featuring energy-efficient appliances and large windows. Enjoy outdoor BBQs, a mudroom, and ample parking—making your new home a breath of fresh air. Lease online today!",
  "property_contactus_blurb": "At Confluence at Harvest Hills, nestled in the heart of Williston, ND, our thoughtfully designed one, two, and three-bedroom apartments balance comfort and style. Each spacious floor plan offers endless possibilities for your personal oasis. Have questions? Contact our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At Confluence at Harvest Hills in Williston, ND, our diverse floor plans—including spacious one, two, and three-bedroom options—are designed to fit your lifestyle. Curious about living here? Browse our FAQs page for answers to your questions and discover what makes our community a perfect home.",
  "property_floorplans_blurb": "At Confluence at Harvest Hills in Williston, ND, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one, two, or three-bedroom options that seamlessly blend comfort and style. Browse our available apartment homes to find the perfect sanctuary that suits your unique needs!",
  "property_gallery_blurb": "At Confluence at Harvest Hills in Williston, ND, picture yourself savoring outdoor BBQs, relaxing on a private balcony, and enjoying spacious, energy-efficient living. Our thoughtfully designed one-, two-, and three-bedroom apartments offer modern amenities and a welcoming community vibe, ensuring every day feels just right. Start envisioning your new home today!",
  "property_interactivemap_blurb": "At Confluence at Harvest Hills in Williston, ND, each spacious apartment shines with modern amenities, from large balconies to energy-efficient appliances. With one, two, and three-bedroom floor plans available, plus an outdoor BBQ area and ample parking, your ideal home is just a click away on our interactive community map!",
  "property_pets_blurb": "At Confluence at Harvest Hills in Williston, ND, your furry friends are part of the family. Embrace a vibrant lifestyle with ample space for pets to roam, while enjoying modern amenities and a supportive community. Pet-friendly living is just the beginning—explore your new home today!",
  "property_referafriend_blurb": "At Confluence at Harvest Hills in Williston, ND, great friends become great neighbors! With one, two, and three-bedroom floor plans, our vibrant community offers the perfect home for every lifestyle. Share the joy—refer a friend today and create lasting memories together in our welcoming haven!",
  "property_residentaccess_blurb": "Welcome to Confluence at Harvest Hills in Williston, ND, where you can choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Enhance your living experience by accessing your resident portal for convenient rent payments, maintenance requests, and more. Login now to streamline your home management!",
  "property_reviews_blurb": "At Confluence at Harvest Hills in Williston, ND, residents rave about the welcoming atmosphere, stating, \"The staff truly makes this place feel like home.\" Dive into our reviews and see firsthand how our vibrant community fosters comfort, connection, and unmatched living experiences. Let our residents' words inspire your next move!",
  "property_created_at": "1771538283700",
  "property_scheduletour_blurb": "At Confluence at Harvest Hills in Williston, ND, choose from thoughtfully designed one, two, and three-bedroom floor plans that perfectly suit your lifestyle. Experience the vibrant community and lush surroundings. Curious about life here? Schedule a tour and see what our residents say about calling this place home!",
  "property_thankyou_blurb": "Thank you for reaching out to Confluence at Harvest Hills in Williston, ND! With versatile floor plans—one, two, or three bedrooms—you'll find the perfect space to call home. Our team is excited to assist you in discovering your ideal apartment lifestyle. Stay tuned for our prompt response!",
  "property_virtualtours_blurb": "Welcome to Confluence at Harvest Hills in Williston, ND, where modern living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Experience your future home like never before—take a virtual tour today and envision your life in this vibrant community!",
  "property_copyright": "2026 All Rights Reserved. Confluence at Harvest Hills",
  "property_seo_title_home": "Find Comfort at Confluence at Harvest Hills Apartments - Williston, ND",
  "property_seo_description_home": "Discover pet-friendly apartments with spacious floor plans, in-unit laundry, and flexible leases at Confluence at Harvest Hills in Williston, ND.",
  "property_seo_title_floorplans": "Spacious Floor Plans at Confluence at Harvest Hills - Williston, ND",
  "property_seo_description_floorplans": "Choose one-, two-, or three-bedroom floor plans with patios, in-unit laundry, and room to work or unwind at Confluence at Harvest Hills in Williston, ND.",
  "property_seo_title_amenities": "Everyday Amenities at Confluence at Harvest Hills - Williston, ND",
  "property_seo_description_amenities": "Enjoy in-home laundry, outdoor grilling areas, and flexible leasing at Confluence at Harvest Hills apartments in Williston, ND.",
  "property_seo_title_gallery": "Photo Gallery of Confluence at Harvest Hills Apartments - Williston, ND",
  "property_seo_description_gallery": "Tour the photo gallery to see spacious floor plans, pet-friendly amenities, and welcoming spaces at Confluence at Harvest Hills in Williston, ND.",
  "property_seo_title_virtualtours": "Confluence at Harvest Hills Virtual Tour - Williston, ND",
  "property_seo_description_virtualtours": "Take a virtual tour of Confluence at Harvest Hills Apartments in Williston, ND, and experience relaxed living from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Confluence at Harvest Hills Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Confluence at Harvest Hills! Use our interactive map to explore spacious layouts, top-notch amenities, and vibrant Williston living.",
  "property_seo_title_neighborhood": "Neighborhood Near Confluence at Harvest Hills - Williston, ND",
  "property_seo_description_neighborhood": "Live close to Cote Park, Williston Municipal Golf Course, and the best dining in Williston, ND at Confluence at Harvest Hills apartments.",
  "property_seo_title_contact": "Contact Confluence at Harvest Hills Apartments - Williston, ND",
  "property_seo_description_contact": "Contact the friendly leasing team at Confluence at Harvest Hills Apartments in Williston, ND, for more details about your new home.",
  "property_seo_title_faqs": "FAQs | Apartments in Williston, ND",
  "property_seo_description_faqs": "Find answers to your questions about Confluence at Harvest Hills in Williston, ND. Enjoy spacious living, exceptional amenities, and a welcoming community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Williston, ND",
  "property_seo_description_reviews": "Experience life at Confluence at Harvest Hills in Williston, ND! See why residents love our spacious apartments and welcoming amenities. Join our community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Williston, ND",
  "property_seo_description_applynow": "Find your perfect space at Confluence at Harvest Hills! Choose from stylish one, two, or three-bedroom apartments in Williston, ND. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Confluence at Harvest Hills",
  "property_seo_description_residentaccess": "Log in to the Harvest Hills resident portal for easy rent payments, fast maintenance requests, and exclusive community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Confluence at Harvest Hills",
  "property_seo_description_referafriend": "Refer a friend to Confluence at Harvest Hills in Williston, ND! Share the joy of great living and enjoy exclusive perks together in our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour at Confluence at Harvest Hills - Williston, ND",
  "property_seo_description_scheduletour": "Book a virtual or in-person tour at Confluence at Harvest Hills in Williston, ND, and discover your next apartment home today.",
  "property_seo_title_privacy": "Privacy Policy | Confluence at Harvest Hills",
  "property_seo_description_privacy": "Your privacy matters at Confluence at Harvest Hills. Dive into our policy to understand how we protect your data in beautiful Williston, ND. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Confluence at Harvest Hills",
  "property_seo_description_accessibility": "At Confluence at Harvest Hills in Williston, ND, we prioritize digital inclusion and ensure accessible living for all. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Confluence at Harvest Hills",
  "property_seo_description_sitemap": "Navigate your way through Confluence at Harvest Hills! Access our sitemap to uncover the array of features and amenities waiting in Williston, ND.",
  "property_seo_title_thankyou": "Thank You | Confluence at Harvest Hills",
  "property_seo_description_thankyou": "Thank you for reaching out! A team member from Confluence at Harvest Hills in Williston, ND, will connect with you soon to discuss your new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Williston, ND",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764155",
  "amenities": [
    {
      "id": "ec_e52d809018d66c2b3d8f893c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830856",
      "title": "Outdoor BBQ Grilling Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ec8c8f0d12529100e11640d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "86770833",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c238174a25235b6649ea0450",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "86770357",
      "title": "24 Hour - Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fedf44484afcf2996ebb5ba6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830852",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ecbc83227ac6ee20acff409",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830849",
      "title": "Energy Efficient Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39a242d4b156ab627fe50069",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "86770836",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_169c665059394ab08cd7234a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "86770835",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a427ac8bf036ff9e4eb0bd9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830854",
      "title": "Mudroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f36ece5356cda24798aaa1f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830855",
      "title": "Ample On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c4accc3c40c44d79edf41e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830846",
      "title": "Roomy Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42649afb38b14c703581f94e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830848",
      "title": "Deep Double Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaf70f633fc6ec3c149ac2fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830857",
      "title": "Pet-Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aebfda17b7693449a061e8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "124800033",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d03a8fe952b0d20a9e5c9a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830850",
      "title": "Convenient Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b077166c7c5ebdd5c8004ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "89830851",
      "title": "Large Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e1e2743745859adf5d5db6c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-8d5b-71fb-af65-94c9c1fdfdc3.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with bar seating",
        "public_id": "019d021e-8d5b-71fb-af65-94c9c1fdfdc3",
        "storage_key": "property/6767906449167191/019d021e-8d5b-71fb-af65-94c9c1fdfdc3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern kitchen with bar seating, a comfortable sofa, and a coffee table.",
      "link": "false",
      "alt_text": "A bright, modern living room here at Confluence at Harvest Hills featuring an open-concept layout with a neutral sofa and armchair, a wooden coffee table on a light area rug, soft beige carpeting, a kitchen breakfast bar with stools, light wood cabinetry, a floor lamp, simple abstract wall art, and large windows allowing natural light to fill the space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(1).jpg"
    },
    {
      "id": "ec_ba982fe8504d87d1e1a33d9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-8ca1-74e9-a188-1beaa6f69a99.webp",
      "image_media": {
        "alt_text": "Primary bedroom with queen-size bed, nightstands, accent chair, and balcony access.",
        "public_id": "019d021e-8ca1-74e9-a188-1beaa6f69a99",
        "storage_key": "property/6767906449167191/019d021e-8ca1-74e9-a188-1beaa6f69a99.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in the spacious primary bedroom featuring a comfortable queen-size bed, elegant nightstands, and a cozy accent chair. Step out onto your private balcony for fresh air.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(7).jpg"
    },
    {
      "id": "ec_b2af8ec6f62fd19d3aa23794",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-8d06-7622-b07a-ae5ac4bce689.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a breakfast bar and stools, refrigerator, stove, and microwave.",
        "public_id": "019d021e-8d06-7622-b07a-ae5ac4bce689",
        "storage_key": "property/6767906449167191/019d021e-8d06-7622-b07a-ae5ac4bce689.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious kitchen with a breakfast bar, stools, and modern appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with brown cabinets and a white refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(8).jpg"
    },
    {
      "id": "ec_6d43d04a44d273af951abd00",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-56e4-72e8-bf4e-e398a9899add.webp",
      "image_media": {
        "alt_text": "Kitchen counter with sink and stools, cabinets and appliances in background",
        "public_id": "019dd7e3-56e4-72e8-bf4e-e398a9899add",
        "storage_key": "property/6767906449167191/019dd7e3-56e4-72e8-bf4e-e398a9899add.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a breakfast bar with seating, ample cabinet space, and a full suite of appliances.",
      "link": "false",
      "alt_text": "A kitchen with a white refrigerator, a white oven, and a white microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(9).jpg"
    },
    {
      "id": "ec_9309088abaa3c43ebe7c35b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-56e5-737c-8264-340d83b0c690.webp",
      "image_media": {
        "alt_text": "Kitchen area with white appliances, wood cabinets, and a double sink.",
        "public_id": "019dd7e3-56e5-737c-8264-340d83b0c690",
        "storage_key": "property/6767906449167191/019dd7e3-56e5-737c-8264-340d83b0c690.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "View of the kitchen area with ample cabinet space, a refrigerator, stove, microwave, and a double sink island.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, microwave, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(10).jpg"
    },
    {
      "id": "ec_ab4d3154f631650fa4245800",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-56e3-7768-9fde-2bc74e53e5ca.webp",
      "image_media": {
        "alt_text": "Kitchen with double sink, dishwasher, and view into living room, bedroom, and bathroom.",
        "public_id": "019dd7e3-56e3-7768-9fde-2bc74e53e5ca",
        "storage_key": "property/6767906449167191/019dd7e3-56e3-7768-9fde-2bc74e53e5ca.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring a double sink and dishwasher, opening to a living area and private bedrooms and bathrooms.",
      "link": "false",
      "alt_text": "A kitchen with wooden cabinets and a tiled floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(11).jpg"
    },
    {
      "id": "ec_9557d11eb837b3dbc79a0e49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-57f3-737a-96e3-e3b12f3b5920.webp",
      "image_media": {
        "alt_text": "View of hallway with doors leading to bedroom and bathroom",
        "public_id": "019dd7e3-57f3-737a-96e3-e3b12f3b5920",
        "storage_key": "property/6767906449167191/019dd7e3-57f3-737a-96e3-e3b12f3b5920.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Hallway inside an apartment unit, showing access to a bedroom and a bathroom. The flooring transitions from carpet to tile.",
      "link": "false",
      "alt_text": "A hallway with a carpeted floor and tiled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(12).jpg"
    },
    {
      "id": "ec_6397a1c61d4eec65abc6f3a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-8cfe-75bb-9905-a4c30c4af9fd.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with shower curtain. Stacked washer and dryer visible in mirror.",
        "public_id": "019d021e-8cfe-75bb-9905-a4c30c4af9fd",
        "storage_key": "property/6767906449167191/019d021e-8cfe-75bb-9905-a4c30c4af9fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit apartment bathroom featuring a spacious vanity, toilet, and a bathtub with a shower curtain. A stacked washer and dryer unit is conveniently located in a closet reflected in the mirror.",
      "link": "false",
      "alt_text": "A bathroom with a toilet, sink, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(13).jpg"
    },
    {
      "id": "ec_96b39711d76cd3a6c62d44bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-96b5-726c-a954-2494fa61f0c4.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer next to a bathroom with a toilet and bathtub with shower curtain.",
        "public_id": "019dd7e3-96b5-726c-a954-2494fa61f0c4",
        "storage_key": "property/6767906449167191/019dd7e3-96b5-726c-a954-2494fa61f0c4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer adjacent to a full bathroom featuring a toilet and a bathtub with a shower curtain.",
      "link": "false",
      "alt_text": "A white washer and dryer in a small laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(14).jpg"
    },
    {
      "id": "ec_45bac401e3a3d39c2a540dac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-96d1-73ff-b8d6-85cbc7574e9a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and toilet; view into kitchen with refrigerator.",
        "public_id": "019dd7e3-96d1-73ff-b8d6-85cbc7574e9a",
        "storage_key": "property/6767906449167191/019dd7e3-96d1-73ff-b8d6-85cbc7574e9a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a wooden vanity with ample storage, a large mirror, and a toilet. Beyond the doorway, a glimpse of the kitchen with a refrigerator is visible.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(15).jpg"
    },
    {
      "id": "ec_5b864eaaef3d636a6020e881",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-98d6-719e-92a1-944d377fbd33.webp",
      "image_media": {
        "alt_text": "Locker room with benches and lockers",
        "public_id": "019d021e-98d6-719e-92a1-944d377fbd33",
        "storage_key": "property/6767906449167191/019d021e-98d6-719e-92a1-944d377fbd33.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "This is a locker room with benches and lockers, an ideal space for residents to store their belongings before or after using community amenities.",
      "link": "false",
      "alt_text": "A room with a tiled floor and a row of benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(16).jpg"
    },
    {
      "id": "ec_f4f5b269d8faf021eb3a125c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019dd7e3-97a9-76eb-a834-e41d27bc3459.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a street in the foreground.",
        "public_id": "019dd7e3-97a9-76eb-a834-e41d27bc3459",
        "storage_key": "property/6767906449167191/019dd7e3-97a9-76eb-a834-e41d27bc3459.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring a striking facade with balconies overlooking a manicured lawn and street.",
      "link": "false",
      "alt_text": "A row of apartment buildings with a white truck parked in front of the first one.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(17).jpg"
    },
    {
      "id": "ec_254ba2b8857687ca84e6d23e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021e-9cc0-71f9-9747-0dbac288ba39.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with colorful siding and balconies.",
        "public_id": "019d021e-9cc0-71f9-9747-0dbac288ba39",
        "storage_key": "property/6767906449167191/019d021e-9cc0-71f9-9747-0dbac288ba39.webp",
        "width": 680,
        "height": 453
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its modern design and amenities. This image highlights the building's facade, balconies, and surrounding green spaces.",
      "link": "false",
      "alt_text": "Apartment complex with a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/ND_Confluence_at_Harvest_Hills_Favorites%20(18).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_24608081-0b9e-49ec-a656-a8d596ed4152",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Meg-A-Latte | Coffee House (Harvest Location)",
      "poi_type": "Restaurants",
      "poi_address": "3210 27th St W Ste 100, Williston, ND 58801, USA",
      "poi_short_description": "Relaxed coffee shop serving espresso and sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0ac8-7309-94b2-605d2789bd1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0ac8-7309-94b2-605d2789bd1c",
        "storage_key": "property/6767906449167191/01a14137-0ac8-7309-94b2-605d2789bd1c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://meg-a-latte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4967303943122330810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meg-a-latte--coffee-house-harvest-location",
      "poi_latitude": "48.1705514",
      "poi_longitude": "-103.6699326",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-609-5270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba25-72e9-954c-633eba92987d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba25-72e9-954c-633eba92987d",
        "storage_key": "property/6767906449167191/019d021f-ba25-72e9-954c-633eba92987d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJH0ZbdVtcIVMRuiQ0TZ5o70Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_a686aa2c-7e1f-4f78-9576-700d4a058930",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Cold Stone Creamery",
      "poi_type": "Restaurants",
      "poi_address": "3210 27th St W STE 106, Williston, ND 58801, USA",
      "poi_short_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_long_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0426-739f-acce-845d1138f41a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0426-739f-acce-845d1138f41a",
        "storage_key": "property/6767906449167191/01a14137-0426-739f-acce-845d1138f41a.webp",
        "width": 1080,
        "height": 600
      },
      "poi_business_url": "https://www.coldstonecreamery.com/stores/23661?utm_source=gmb&utm_medium=gmb&utm_campaign=gmb&utm_id=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6099982625267681432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cold-stone-creamery",
      "poi_latitude": "48.1703753",
      "poi_longitude": "-103.6703966",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 701-572-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8Rz96-FdIVMRmIgi6-B9p1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_c4ab4ccf-4b3b-4b28-8583-a9841c7fcd10",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "401 Reiger Dr, Williston, ND 58801, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-abaf-7215-a8bc-0374731b5dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-abaf-7215-a8bc-0374731b5dcb",
        "storage_key": "property/6767906449167191/01a14135-abaf-7215-a8bc-0374731b5dcb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.culvers.com/restaurants/williston-nd/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10401132715212886260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "48.1472436",
      "poi_longitude": "-103.6562221",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-713-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw21QL39cIVMR9FD1zxg_WJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4a36b921-927f-4788-812d-edf8db73f7a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "6 26th St W, Williston, ND 58801, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0a7f-773d-acd8-d5290bd181f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0a7f-773d-acd8-d5290bd181f4",
        "storage_key": "property/6767906449167191/01a14137-0a7f-773d-acd8-d5290bd181f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/nd/williston/6-26th-street-west-95005?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=95005&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=5338516987472716408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "48.1691817",
      "poi_longitude": "-103.6225996",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-4769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy8VcmrhcIVMReCKzWeo4Fko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0caddb1f-9861-4d95-a61f-2b5e5e84f1a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Gramma Sharon's | Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1501 16th St W, Williston, ND 58801, USA",
      "poi_short_description": "Hopping option for old-fashioned American breakfast & lunch items in an unassuming space.",
      "poi_long_description": "Hopping option for old-fashioned American breakfast & lunch items in an unassuming space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0200-706b-8a65-3f6d20d2e371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0200-706b-8a65-3f6d20d2e371",
        "storage_key": "property/6767906449167191/01a14137-0200-706b-8a65-3f6d20d2e371.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://grammasharon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=138698920719298724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gramma-sharons--family-restaurant",
      "poi_latitude": "48.1595251",
      "poi_longitude": "-103.6457704",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-572-1412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ277Y5cIVMRpDA0_O7B7AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_251bb967-ba5c-4247-8267-6a11a5ebb0b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Don Pedro's Family Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2516 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Welcoming family-style Mexican restaurant serving authentic entrees, appetizers, and margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0eb4-728b-abc5-88c6135f1d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0eb4-728b-abc5-88c6135f1d97",
        "storage_key": "property/6767906449167191/01a14137-0eb4-728b-abc5-88c6135f1d97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://donpedrosfamilymexicanrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4625387231967667153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-pedros-family-mexican-restaurant",
      "poi_latitude": "48.1681038",
      "poi_longitude": "-103.6252529",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-774-1151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJczFRPL9cIVMR0WMPXi6tMEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_5555845c-a94d-4b98-8a92-2cb04f04fb7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "3 Amigos Southwest Grill",
      "poi_type": "Restaurants",
      "poi_address": "1007 Main St Unit a, Williston, ND 58801, USA",
      "poi_short_description": "Casual spot for Southwestern/Tex-Mex burritos, bowls & salads for breakfast, lunch & dinner.",
      "poi_long_description": "Casual spot for Southwestern/Tex-Mex burritos, bowls & salads for breakfast, lunch & dinner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-6837-73ee-bc11-45c44accff45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-6837-73ee-bc11-45c44accff45",
        "storage_key": "property/6767906449167191/019d021f-6837-73ee-bc11-45c44accff45.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://3amigosgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2287633132283862312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3-amigos-southwest-grill",
      "poi_latitude": "48.153966",
      "poi_longitude": "-103.623631",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-577-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzcjC-qFcIVMRKJ0xojZOvx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8da0226b-fc97-42e5-8eef-7780c38dee7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston | Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1623 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Lively, late-night gastropub serving classic bar fare, plus 40 tap beers & an ample wine list.",
      "poi_long_description": "Lively, late-night gastropub serving classic bar fare, plus 40 tap beers & an ample wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-58ce-77bb-a367-feddf4aaabb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-58ce-77bb-a367-feddf4aaabb4",
        "storage_key": "property/6767906449167191/019d021f-58ce-77bb-a367-feddf4aaabb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.willistonbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7638704886454672961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston--brewing-company",
      "poi_latitude": "48.160603599999995",
      "poi_longitude": "-103.6264419",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-609-5439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30YNab1cIVMRQd4rZZ8hAmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_654c2ab0-456d-4318-8d6c-cebeb86de981",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "3E Restaurant & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "14 2nd St W, Williston, ND 58801, USA",
      "poi_short_description": "Cozy Turkish restaurant offering authentic kebabs and signature baklava.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-024b-756f-b9ca-df5bc3763ba1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-024b-756f-b9ca-df5bc3763ba1",
        "storage_key": "property/6767906449167191/01a14137-024b-756f-b9ca-df5bc3763ba1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.3epastrycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1651882545571397854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3e-restaurant--cafe",
      "poi_latitude": "48.1455693",
      "poi_longitude": "-103.6224734",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-609-5457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxBqoEFbIVMR3oBzU2yq7BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "turkish_restaurant"
    },
    {
      "id": "custom_b6a0aae6-8cf9-4b1c-909a-a82a12fed1de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Dakota Farms Restaurant Williston",
      "poi_type": "Restaurants",
      "poi_address": "1906 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Hometown American eatery serving hearty breakfast favorites like pancakes, omelets, and hashbrowns.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-01f5-776f-a8a3-090e102072fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-01f5-776f-a8a3-090e102072fa",
        "storage_key": "property/6767906449167191/01a14137-01f5-776f-a8a3-090e102072fa.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.dakotafarmsrestaurants.com/williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=1845612146336984275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakota-farms-restaurant-williston",
      "poi_latitude": "48.162544999999994",
      "poi_longitude": "-103.625242",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-4480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ25Wssb1cIVMR0-yP93funBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c7b93215-2fd6-404a-9bf2-39c8990d3b56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Basil | Sushi Bar and Asian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "16 E Broadway, Williston, ND 58801, USA",
      "poi_short_description": "Creative rolls, sake drinks & a variety of Asian entrees are presented in cheerful surroundings.",
      "poi_long_description": "Creative rolls, sake drinks & a variety of Asian entrees are presented in cheerful surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0ace-73ba-8ac7-c20bf57155a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0ace-73ba-8ac7-c20bf57155a9",
        "storage_key": "property/6767906449167191/01a14137-0ace-73ba-8ac7-c20bf57155a9.webp",
        "width": 1125,
        "height": 1070
      },
      "poi_business_url": "http://www.basilwilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9809154802061283946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "basil--sushi-bar-and-asian-bistro",
      "poi_latitude": "48.1464174",
      "poi_longitude": "-103.6208273",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-6688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJix95hWBbIVMRahKuQ1IeIYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_67877894-6654-4007-8334-95b7352ab9a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Noodles and Company",
      "poi_type": "Restaurants",
      "poi_address": "3721 2nd Ave W Suite 103, Williston, ND 58801, USA",
      "poi_short_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_long_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-11e8-708a-be89-47237ce09b40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-11e8-708a-be89-47237ce09b40",
        "storage_key": "property/6767906449167191/01a14137-11e8-708a-be89-47237ce09b40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.noodles.com/nd/williston/3715-2nd-ave-w?utm_campaign=soci&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=1761753141376606400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodles-and-company",
      "poi_latitude": "48.179061999999995",
      "poi_longitude": "-103.627044",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-713-9229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQHoPEddIVMRwGCu3SUBcxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_61bd807f-47dd-4641-a45b-4fa44e6532b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "417 Reiger Dr, Williston, ND 58801, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0ad1-720e-a67b-c386decb4bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0ad1-720e-a67b-c386decb4bb9",
        "storage_key": "property/6767906449167191/01a14137-0ad1-720e-a67b-c386decb4bb9.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.buffalowildwings.com/locations/us/nd/williston/417-reiger-drive/sports-bar-1288?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTA1My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2371319050961739127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "48.1480559",
      "poi_longitude": "-103.6540357",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-609-5445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ684tV15bIVMRd92w8Rye6CA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_fe6a5f63-c742-407a-80b7-b6080f8768eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Famous Dave's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "1518 14th St W, Williston, ND 58801, USA",
      "poi_short_description": "Outlet of a BBQ chain serving wood-smoked meats & sides in an American West-themed space.",
      "poi_long_description": "Outlet of a BBQ chain serving wood-smoked meats & sides in an American West-themed space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-0f1f-74aa-923c-38663705e402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-0f1f-74aa-923c-38663705e402",
        "storage_key": "property/6767906449167191/01a14137-0f1f-74aa-923c-38663705e402.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.famousdaves.com/Williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=6837899946649626061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "famous-daves-bar-b-que",
      "poi_latitude": "48.157688",
      "poi_longitude": "-103.645866",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-609-5459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJATpXT49cIVMRzaW20cUZ5V4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_d2858463-bcd4-4022-a024-37f040ef05b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "The Egg Tequila | Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2406 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Versatile Mexican restaurant serving a wide variety of meals and breakfast favorites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-182e-7355-82aa-e0895d07e0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-182e-7355-82aa-e0895d07e0d8",
        "storage_key": "property/6767906449167191/01a14137-182e-7355-82aa-e0895d07e0d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100066296661052",
      "poi_directions_map_url": "https://maps.google.com/?cid=11754625386763611241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-egg-tequila--family-restaurant",
      "poi_latitude": "48.1672149",
      "poi_longitude": "-103.6251782",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-572-6677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba2d-70ad-ada7-44f8befcaab8",
        "storage_key": "property/6767906449167191/019d021f-ba2d-70ad-ada7-44f8befcaab8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwHQQJ9dIVMRaWzVtYLRIKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_634f1ea0-ba15-44c7-857e-67fe615a0d11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Cash Wise Foods Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 11th St W, Williston, ND 58801, USA",
      "poi_short_description": "Comprehensive grocery store featuring a well-regarded meat department and deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-a878-7311-8060-741969e56a50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-a878-7311-8060-741969e56a50",
        "storage_key": "property/6767906449167191/01a14135-a878-7311-8060-741969e56a50.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://cashwise.com/CWstore3046?utm_source=local+listing&utm_medium=organic&utm_campaign=grocery&utm_id=williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=14969500372833607189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cash-wise-foods-grocery-store",
      "poi_latitude": "48.1549899",
      "poi_longitude": "-103.6277601",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-2927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdda-7328-9be3-20a71feca8a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdda-7328-9be3-20a71feca8a2",
        "storage_key": "property/6767906449167191/019d021f-bdda-7328-9be3-20a71feca8a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0DN25hcIVMRFR7T-0ZZvs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2c852694-b87f-44e9-9fcf-3824bff457c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Thrifty White Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "300 11th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-15d8-708f-98dd-6cfd2d63af06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-15d8-708f-98dd-6cfd2d63af06",
        "storage_key": "property/6767906449167191/01a14137-15d8-708f-98dd-6cfd2d63af06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thriftywhite.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5875788732181604851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrifty-white-pharmacy",
      "poi_latitude": "48.155183",
      "poi_longitude": "-103.62774960000002",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-774-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdc4-7290-971d-12775175acbb",
        "storage_key": "property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCaXN05hcIVMR82ntfLj-ilE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_341511b4-c7a7-47b0-bb7f-21a4bc1d5d20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "G & G Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 14th St W #150, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-1307-71ac-92b7-06099241be80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-1307-71ac-92b7-06099241be80",
        "storage_key": "property/6767906449167191/01a14137-1307-71ac-92b7-06099241be80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ggpharmacynd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17635100720682523643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "g--g-pharmacy",
      "poi_latitude": "48.157218699999994",
      "poi_longitude": "-103.6438171",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-572-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdc4-7290-971d-12775175acbb",
        "storage_key": "property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVjWeo9cIVMR-1uEsqt2vPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_42603a92-81d1-4b85-a352-3ae94e726bd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 26th St E, Williston, ND 58801, USA",
      "poi_short_description": "Well-stocked grocery store featuring a bakery, deli, and fresh produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-70c3-7674-b7e0-ad1516b61ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-70c3-7674-b7e0-ad1516b61ba9",
        "storage_key": "property/6767906449167191/019d021f-70c3-7674-b7e0-ad1516b61ba9.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.albertsons.com/nd/williston/20-26th-st-e.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12500285439156409754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "48.1676414",
      "poi_longitude": "-103.6225053",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-1097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdda-7328-9be3-20a71feca8a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdda-7328-9be3-20a71feca8a2",
        "storage_key": "property/6767906449167191/019d021f-bdda-7328-9be3-20a71feca8a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRfZlbhcIVMRmtXnp2Dvea0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9c5254d3-0487-4a9b-848f-bc0d9ccd31f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Large department store offering a wide selection of groceries, electronics, and home goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-6f09-72fe-8079-b5fc6a2a799e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-6f09-72fe-8079-b5fc6a2a799e",
        "storage_key": "property/6767906449167191/019d021f-6f09-72fe-8079-b5fc6a2a799e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1565-williston-nd/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11230564822295575906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "48.1821784",
      "poi_longitude": "-103.6299819",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi9oxDNpcIVMRYv3sKzT72ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1cd1c3b1-2001-436e-9a0b-3e91f675b623",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Fuel Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "3014 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-1ad1-754d-93dd-091e0276668f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-1ad1-754d-93dd-091e0276668f",
        "storage_key": "property/6767906449167191/01a14137-1ad1-754d-93dd-091e0276668f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3967103178089643319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-fuel-plaza",
      "poi_latitude": "48.172915499999995",
      "poi_longitude": "-103.6251073",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-572-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e",
        "storage_key": "property/6767906449167191/01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJiyl928ZcIVMRNz1bZVL7DTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d2ff095e-de3f-4066-89de-764380808efb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Simonson Station Stores",
      "poi_type": "Transportation & Transit",
      "poi_address": "1409 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Gas station and convenience store offering ethanol-free fuel, EV charging, and car wash services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-1d35-709d-bbeb-4195a97d63ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-1d35-709d-bbeb-4195a97d63ef",
        "storage_key": "property/6767906449167191/01a14137-1d35-709d-bbeb-4195a97d63ef.webp",
        "width": 1280,
        "height": 812
      },
      "poi_business_url": "https://gosimonson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14400820728668311457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simonson-station-stores",
      "poi_latitude": "48.1582561",
      "poi_longitude": "-103.6262034",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdd5-739c-8e35-1e1e8167e605.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdd5-739c-8e35-1e1e8167e605",
        "storage_key": "property/6767906449167191/019d021f-bdd5-739c-8e35-1e1e8167e605.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZvZo6JcIVMRoU9bZif-2cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_ba65f780-b6b5-4f02-ba36-eedb8ff04392",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Superpumper - Convenience Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1621 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gosuperpumper.com/?utm_source=G&utm_medium=lpm&utm_campaign=parkland",
      "poi_directions_map_url": "https://maps.google.com/?cid=17928837247501411330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "superpumper---convenience-store",
      "poi_latitude": "48.160233299999994",
      "poi_longitude": "-103.6260938",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-0759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e",
        "storage_key": "property/6767906449167191/01a14137-5b4b-74fc-b2c0-4f83ec1e2d9e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ10FLRr1cIVMRAiQdTXwG0Pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_bd014fca-e92d-431d-85db-2fdf50500fc5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "302 Bean Dr, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-18e1-700a-9657-5b52bb1fc602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-18e1-700a-9657-5b52bb1fc602",
        "storage_key": "property/6767906449167191/01a14137-18e1-700a-9657-5b52bb1fc602.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nd/williston/30342",
      "poi_directions_map_url": "https://maps.google.com/?cid=3564136214950256535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "48.147796",
      "poi_longitude": "-103.600318",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-829-0725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyUV4iglbIVMRlx83_wBbdjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_47440cf5-3e2a-4d57-a22b-e051fb6e163e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Runnings",
      "poi_type": "Shopping & Retail",
      "poi_address": "2102 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Longtime chain retailer with a wide array of home & farm supplies & outdoor recreation equipment.",
      "poi_long_description": "Longtime chain retailer with a wide array of home & farm supplies & outdoor recreation equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3307-70bd-946d-53ecb6cec73b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3307-70bd-946d-53ecb6cec73b",
        "storage_key": "property/6767906449167191/01a14137-3307-70bd-946d-53ecb6cec73b.webp",
        "width": 1280,
        "height": 799
      },
      "poi_business_url": "https://www.runnings.com/storelocator/store/williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=707089415200147654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "runnings",
      "poi_latitude": "48.1640199",
      "poi_longitude": "-103.624882",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-7626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9_UFLbxcIVMRxohxqRMW0Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d177c9fa-b2ba-49a7-85df-bcb724cba250",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Hagan Elementary School",
      "poi_type": "Education",
      "poi_address": "2501 29th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-1f91-75d5-bb23-e8f92c54c8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-1f91-75d5-bb23-e8f92c54c8d7",
        "storage_key": "property/6767906449167191/01a14137-1f91-75d5-bb23-e8f92c54c8d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hagan.willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16199069979458394180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagan-elementary-school",
      "poi_latitude": "48.1713161",
      "poi_longitude": "-103.6589952",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-572-4960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM1roXfZcIVMRRNhP6VGozuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_348a55db-d7fd-4f36-ab22-10cabee06371",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "WMSCC - Bakken Ridge",
      "poi_type": "Education",
      "poi_address": "502 W Highland Dr, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12041659573755251916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wmscc---bakken-ridge",
      "poi_latitude": "48.1563597",
      "poi_longitude": "-103.6301348",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-713-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAYu_pplcIVMRzAzdN5WRHKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_1018615d-61e0-4311-91bf-f875dbd09de8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Middle School Central Campus",
      "poi_type": "Education",
      "poi_address": "501 14th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://willistonschools.org/wmscc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7216270442641779983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-middle-school-central-campus",
      "poi_latitude": "48.1572478",
      "poi_longitude": "-103.6301008",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 701-572-5618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJVl_z5lcIVMRD23Q8LtXJWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_89919c68-007c-4a0f-af33-cd8798f1d12e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston High School",
      "poi_type": "Education",
      "poi_address": "Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-20a6-75ac-a2ed-ee494b3b2dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-20a6-75ac-a2ed-ee494b3b2dd0",
        "storage_key": "property/6767906449167191/01a14137-20a6-75ac-a2ed-ee494b3b2dd0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.willistonschools.org/o/whs",
      "poi_directions_map_url": "https://maps.google.com/?cid=4590942202403288911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-high-school",
      "poi_latitude": "48.1775543",
      "poi_longitude": "-103.6823726",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-572-0967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTIXI0xcIVMRT_eY9ptNtj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9dbb2102-7c88-497a-8aaf-3ef9c812ba8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "McVay Elementary School",
      "poi_type": "Education",
      "poi_address": "420 University Ave, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mcvay.willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14955508013454485760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcvay-elementary-school",
      "poi_latitude": "48.1487072",
      "poi_longitude": "-103.6145771",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-572-9104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIU3gLF9bIVMRAGl28UyjjM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6479a3db-f883-4ebe-8c0e-fa01b20ea9c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Rickard Elementary School",
      "poi_type": "Education",
      "poi_address": "1224 1st Ave E, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rickard.willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12462965352781965175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rickard-elementary-school",
      "poi_latitude": "48.1564851",
      "poi_longitude": "-103.6209492",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAVqdtqNcIVMRd-eR7PRY9aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f9054213-398e-4f25-bbf8-392f6e9ecdf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Wilkinson Elementary School",
      "poi_type": "Education",
      "poi_address": "1200 9th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wilkinson.willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17687905020230180775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilkinson-elementary-school",
      "poi_latitude": "48.158868899999995",
      "poi_longitude": "-103.6405419",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-572-6532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFS5jGZtcIVMRpx-rv-YPePU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9ebec2e7-95ac-4e30-a48a-ba4fd9d58328",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston State College",
      "poi_type": "Education",
      "poi_address": "1410 University Ave, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-b002-719f-b435-ad7db2b6d84f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-b002-719f-b435-ad7db2b6d84f",
        "storage_key": "property/6767906449167191/01a14135-b002-719f-b435-ad7db2b6d84f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.willistonstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710514784045835372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-state-college",
      "poi_latitude": "48.1582319",
      "poi_longitude": "-103.6126246",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-774-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsaRzp6VcIVMRbCQDsCYbhKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_42be014a-c32e-48ed-be27-9d93a75d6ac5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Head Start",
      "poi_type": "Education",
      "poi_address": "420 University Ave, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-2322-74cf-9d0c-9b903a1b632f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-2322-74cf-9d0c-9b903a1b632f",
        "storage_key": "property/6767906449167191/01a14137-2322-74cf-9d0c-9b903a1b632f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.savethechildren.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7603741733908396991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-head-start",
      "poi_latitude": "48.1487072",
      "poi_longitude": "-103.6145771",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-214-4053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyU3gLF9bIVMRvztsFdLqhWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b5a300f0-2ab1-409b-bcfa-ea638ed20be9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Amy's Angels Childcare",
      "poi_type": "Education",
      "poi_address": "512 17th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-21de-71c1-8ce4-b22b40529eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-21de-71c1-8ce4-b22b40529eb6",
        "storage_key": "property/6767906449167191/01a14137-21de-71c1-8ce4-b22b40529eb6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17867336925847563171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amys-angels-childcare",
      "poi_latitude": "48.160843799999995",
      "poi_longitude": "-103.6312989",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-601-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-fxv8gZdIVMRoytd00SI9fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_311e1b81-7430-422a-aad1-7dd9aaf880f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Area Recreation Center (ARC)",
      "poi_type": "Health and Wellness",
      "poi_address": "822 18th St E, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-86fe-735d-b841-7952ac1415cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-86fe-735d-b841-7952ac1415cb",
        "storage_key": "property/6767906449167191/019d021f-86fe-735d-b841-7952ac1415cb.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11927299787210179051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-area-recreation-center-arc",
      "poi_latitude": "48.1606975",
      "poi_longitude": "-103.6092021",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-9272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUExIq5cIVMR60FBgvZHhqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_31bc1221-af46-4a51-af9e-2d51d7f04874",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Strike Zone",
      "poi_type": "Entertainment",
      "poi_address": "1804 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Family-friendly bowling alley featuring an arcade and pizza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-2a71-744e-96c6-96513a803897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-2a71-744e-96c6-96513a803897",
        "storage_key": "property/6767906449167191/01a14137-2a71-744e-96c6-96513a803897.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://strikezonend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1076140136670890994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strike-zone",
      "poi_latitude": "48.1617701",
      "poi_longitude": "-103.6251341",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh51uqL1cIVMR8gvPrsA37w4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_1d654751-8a6a-4d96-8f8c-767b871a68dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Grand Theatre",
      "poi_type": "Entertainment",
      "poi_address": "211 Main St #6020, Williston, ND 58801, USA",
      "poi_short_description": "Vintage movie house now showing first-run Hollywood films on 6 screens across two buildings.",
      "poi_long_description": "Vintage movie house now showing first-run Hollywood films on 6 screens across two buildings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-263a-767b-9893-bab421cf6086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-263a-767b-9893-bab421cf6086",
        "storage_key": "property/6767906449167191/01a14137-263a-767b-9893-bab421cf6086.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.willistonmovies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10778013362090435185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-theatre",
      "poi_latitude": "48.1459871",
      "poi_longitude": "-103.6219222",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-2232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16f-728a-9586-64b626bcbdce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16f-728a-9586-64b626bcbdce",
        "storage_key": "property/6767906449167191/019d021f-c16f-728a-9586-64b626bcbdce.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxyelmBbIVMRcWLQZwwyk5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_90437164-19a3-4f66-8d5d-aaba6c22108f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Old Armory",
      "poi_type": "Entertainment",
      "poi_address": "320 1st Ave E, Williston, ND 58801, USA",
      "poi_short_description": "Historical event space that's also used for weddings, craft fairs and meetings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-2c60-71fb-b203-66d2f42e779d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-2c60-71fb-b203-66d2f42e779d",
        "storage_key": "property/6767906449167191/01a14137-2c60-71fb-b203-66d2f42e779d.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.willistonoldarmory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6109126646529241197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-armory",
      "poi_latitude": "48.147497",
      "poi_longitude": "-103.6200242",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-577-0278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b60-75ed-b42c-10de367adf65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b60-75ed-b42c-10de367adf65",
        "storage_key": "property/6767906449167191/01a14137-5b60-75ed-b42c-10de367adf65.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQyCLl5bIVMRbbA_RlH6x1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_f872d927-d755-4343-a40f-20b29f239097",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "James Memorial Art Center",
      "poi_type": "Entertainment",
      "poi_address": "621 1st Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Gallery for art exhibits and classes, as well as a rental venue for parties and functions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-34ff-71d6-9f2a-db64f57f959c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-34ff-71d6-9f2a-db64f57f959c",
        "storage_key": "property/6767906449167191/01a14137-34ff-71d6-9f2a-db64f57f959c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thejamesmemorial.org/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8828742624757859875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-memorial-art-center",
      "poi_latitude": "48.1501031",
      "poi_longitude": "-103.6243085",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-774-3601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b59-7007-848c-4abaaf6a14bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b59-7007-848c-4abaaf6a14bf",
        "storage_key": "property/6767906449167191/01a14137-5b59-7007-848c-4abaaf6a14bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwJG559cIVMRI8YK-qP-hXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_ba2ea617-7d4a-42c0-90b9-e1870fa578f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Missouri-Yellowstone Confluence Interpretive Center",
      "poi_type": "Entertainment",
      "poi_address": "15349 39th Ln NW, Williston, ND 58801, USA",
      "poi_short_description": "Informative museum featuring local history exhibits and scenic riverfront walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-8f21-735d-adf3-a424aa7d2a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-8f21-735d-adf3-a424aa7d2a8c",
        "storage_key": "property/6767906449167191/019d021f-8f21-735d-adf3-a424aa7d2a8c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://history.nd.gov/historicsites/mycic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2483539475366114312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "missouri-yellowstone-confluence-interpretive-center",
      "poi_latitude": "47.9850437",
      "poi_longitude": "-103.9887745",
      "poi_miles_from_property": "23.2",
      "poi_walking_minutes": "8 hours 19 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 701-572-9034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c196-76db-ba6d-10e486136e12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c196-76db-ba6d-10e486136e12",
        "storage_key": "property/6767906449167191/019d021f-c196-76db-ba6d-10e486136e12.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYKIWlHwI1MRCHTblv5NdyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_705ada8e-6b14-49cf-beab-e8cf3e0169b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Fort Buford State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "15349 39th Ln NW, Williston, ND 58801, USA",
      "poi_short_description": "Historic site featuring a 19th-century military post with a museum in the officers' quarters.",
      "poi_long_description": "Historic site featuring a 19th-century military post with a museum in the officers' quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-2e0a-722a-a07f-70ca064b039a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-2e0a-722a-a07f-70ca064b039a",
        "storage_key": "property/6767906449167191/01a14137-2e0a-722a-a07f-70ca064b039a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.history.nd.gov/historicsites/buford",
      "poi_directions_map_url": "https://maps.google.com/?cid=15876816456925892406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-buford-state-historic-site",
      "poi_latitude": "47.987658",
      "poi_longitude": "-104.000413",
      "poi_miles_from_property": "23.5",
      "poi_walking_minutes": "8 hours 26 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 701-572-9034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-e035-707f-a0eb-3c9bf8c738c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14135-e035-707f-a0eb-3c9bf8c738c6",
        "storage_key": "property/6767906449167191/01a14135-e035-707f-a0eb-3c9bf8c738c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVGX7F_wI1MRNs8k13LIVdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_e98a1462-5b80-4f00-bdb6-904d2cfba3c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "The Range Clubhouse & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "10 1st Ave E, Williston, ND 58801, USA",
      "poi_short_description": "Chain retailer selling home, garden & leisure products, including furniture & kitchen equipment.",
      "poi_long_description": "Chain retailer selling home, garden & leisure products, including furniture & kitchen equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-33f2-732c-bdd8-198d2bb4d912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-33f2-732c-bdd8-198d2bb4d912",
        "storage_key": "property/6767906449167191/01a14137-33f2-732c-bdd8-198d2bb4d912.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rangend.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17968483049838096320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-range-clubhouse--lounge",
      "poi_latitude": "48.143901",
      "poi_longitude": "-103.6194061",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-713-4487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba23-71ba-aa6e-e82113fbd9bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba23-71ba-aa6e-e82113fbd9bf",
        "storage_key": "property/6767906449167191/019d021f-ba23-71ba-aa6e-e82113fbd9bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJczCcUcldIVMRwC86-iHgXPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_c054e90a-23fa-4516-8dbc-3230793af3a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Upper Missouri Valley Fair",
      "poi_type": "Entertainment",
      "poi_address": "519 53rd St E, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3570-77c8-b45a-6e9e3c2fc265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3570-77c8-b45a-6e9e3c2fc265",
        "storage_key": "property/6767906449167191/01a14137-3570-77c8-b45a-6e9e3c2fc265.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.umvf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5153501935691842093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-missouri-valley-fair",
      "poi_latitude": "48.1947116",
      "poi_longitude": "-103.6106013",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-572-3338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b60-75ed-b42c-10de367adf65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b60-75ed-b42c-10de367adf65",
        "storage_key": "property/6767906449167191/01a14137-5b60-75ed-b42c-10de367adf65.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zwJNJtcIVMRLUIzwrTqhEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_7ad5a1c6-6c90-4589-877e-15a7a866e65b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "CHI St. Alexius Health Williston Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 15th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-8fa8-73db-8bc7-46ba48095901.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-8fa8-73db-8bc7-46ba48095901",
        "storage_key": "property/6767906449167191/019d021f-8fa8-73db-8bc7-46ba48095901.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.chistalexiushealth.org/locations/williston",
      "poi_directions_map_url": "https://maps.google.com/?cid=18263497799483371781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chi-st-alexius-health-williston-medical-center",
      "poi_latitude": "48.155688999999995",
      "poi_longitude": "-103.6456821",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-572-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c234-7579-b8f5-1c53b0250aef",
        "storage_key": "property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWyH2IVcIVMRBbFVBnz6dP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8aafd681-1b8c-4c27-94ed-fa6d6d798198",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "McKenzie Health Center - Williston West",
      "poi_type": "Health and Wellness",
      "poi_address": "1542 16th St W #300, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3af9-77dd-b647-42bac74b7d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3af9-77dd-b647-42bac74b7d0c",
        "storage_key": "property/6767906449167191/01a14137-3af9-77dd-b647-42bac74b7d0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mckenziehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9052045727399822964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-health-center---williston-west",
      "poi_latitude": "48.159024900000006",
      "poi_longitude": "-103.6465746",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-577-6337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c234-7579-b8f5-1c53b0250aef",
        "storage_key": "property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwc8wGQBdIVMRdEZCGKFTn30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6354dd85-ad37-4566-9c43-21c59ef08734",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Service Drug Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "317 Main St, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3a08-71ca-a60a-8ff0c8f811fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3a08-71ca-a60a-8ff0c8f811fa",
        "storage_key": "property/6767906449167191/01a14137-3a08-71ca-a60a-8ff0c8f811fa.webp",
        "width": 515,
        "height": 472
      },
      "poi_business_url": "https://www.mygnp.com/pharmacies/service-drug-pharmacy-williston-nd-58801/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3504948",
      "poi_directions_map_url": "https://maps.google.com/?cid=8646957217653193006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "service-drug-pharmacy",
      "poi_latitude": "48.1472449",
      "poi_longitude": "-103.6220948",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-572-6721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdc4-7290-971d-12775175acbb",
        "storage_key": "property/6767906449167191/019d021f-bdc4-7290-971d-12775175acbb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmb96Y2BbIVMRLvk3osYpAHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9e3b5c3a-30a9-49fd-ae1e-de6b28d9a966",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1542 16th St W, Williston, ND 58801, USA",
      "poi_short_description": "24/7 gym featuring a diverse selection of workout and cardio equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-bc16-738c-aa01-2a1f539da4b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-bc16-738c-aa01-2a1f539da4b9",
        "storage_key": "property/6767906449167191/01a14135-bc16-738c-aa01-2a1f539da4b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/williston-north-dakota-778/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=778",
      "poi_directions_map_url": "https://maps.google.com/?cid=2414718842232582961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "48.1592209",
      "poi_longitude": "-103.6468703",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-1935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_hD6I5cIVMRMTO3R_7NgiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a72812e-c831-46b0-a457-ea8ae63cdf0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Full Circle Strength Systems",
      "poi_type": "Health and Wellness",
      "poi_address": "412 47th St W, Williston, ND 58801, USA",
      "poi_short_description": "Gym offering a range of weightlifting equipment and supplements, plus personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3ab7-76cd-abb7-f9d3ca05769e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3ab7-76cd-abb7-f9d3ca05769e",
        "storage_key": "property/6767906449167191/01a14137-3ab7-76cd-abb7-f9d3ca05769e.webp",
        "width": 1080,
        "height": 813
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15930966016994939512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "full-circle-strength-systems",
      "poi_latitude": "48.1882801",
      "poi_longitude": "-103.6294007",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-774-5036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSGzMrlcIVMReJLNwy8pFt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_019096c0-1d03-4016-a03d-98e785305ab5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Exhale Yoga & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "125 Main Street Unit B, 125 Main St Unit d, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-990c-7418-8405-cbe2bc74c231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-990c-7418-8405-cbe2bc74c231",
        "storage_key": "property/6767906449167191/019d021f-990c-7418-8405-cbe2bc74c231.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.exhaleyogand.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8262465853205235330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exhale-yoga--wellness",
      "poi_latitude": "48.1451785",
      "poi_longitude": "-103.6218927",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-609-3953",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_8y6epcIVMRgsYXxeosqnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_a48bc28a-b086-493b-a3ef-f13cf52f3851",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Sunday Skin Aesthetics + Wellness",
      "poi_type": "Shopping & Retail",
      "poi_address": "311 Main St, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-3d2b-72fd-bb99-b932d887134e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-3d2b-72fd-bb99-b932d887134e",
        "storage_key": "property/6767906449167191/01a14137-3d2b-72fd-bb99-b932d887134e.webp",
        "width": 1280,
        "height": 883
      },
      "poi_business_url": "http://www.sundayskinwilliston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7193721059316463479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunday-skin-aesthetics--wellness",
      "poi_latitude": "48.1469781",
      "poi_longitude": "-103.6222088",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-577-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-bdae-740b-86fe-7fda205da41f",
        "storage_key": "property/6767906449167191/019d021f-bdae-740b-86fe-7fda205da41f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdxVz9K1dIVMRd_fNgTA71WM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_6e9d5852-0fd1-441f-9945-b727e8318b97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Cote Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3700 37th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-40d5-7297-856d-6b35b415eef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-40d5-7297-856d-6b35b415eef8",
        "storage_key": "property/6767906449167191/01a14137-40d5-7297-856d-6b35b415eef8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170395709200480304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cote-park",
      "poi_latitude": "48.1793932",
      "poi_longitude": "-103.6737415",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 701-572-9272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-gvS5FdIVMRMDi1Q8044Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cde9e022-c1b2-4ff9-979d-162a22c98568",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Pheasant Run Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1800 28th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-42a8-7646-81d8-7711c540008d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-42a8-7646-81d8-7711c540008d",
        "storage_key": "property/6767906449167191/01a14137-42a8-7646-81d8-7711c540008d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13739425905289865785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pheasant-run-park",
      "poi_latitude": "48.1702837",
      "poi_longitude": "-103.6501308",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN9FPyPNcIVMROSqa9hA_rL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b60f6f0d-4e6c-4559-b5a6-5277e6097cd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Western Star Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 19th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Family-friendly park featuring a ball field, playground, and ice rink.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-d052-7459-a124-feac417bf046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-d052-7459-a124-feac417bf046",
        "storage_key": "property/6767906449167191/01a14135-d052-7459-a124-feac417bf046.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.willistonparks.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=684879181734047739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-star-complex",
      "poi_latitude": "48.159403399999995",
      "poi_longitude": "-103.6501259",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3_5AolcIVMR-29RtfwtgQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5135e953-0877-458d-a9b6-5f1fa3c802e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Recreation Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "209 4th St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-41d9-7468-85c1-8fb9b56583a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-41d9-7468-85c1-8fb9b56583a2",
        "storage_key": "property/6767906449167191/01a14137-41d9-7468-85c1-8fb9b56583a2.webp",
        "width": 590,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2937002213329472733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "recreation-park",
      "poi_latitude": "48.1473406",
      "poi_longitude": "-103.6263289",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 515-802-0948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7jx1fxbIVMR3QwKvvNTwig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_a5f8ec21-1d42-46ba-80d0-e7f76335789b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Spring Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Spring Lake Park, 5906 2nd Ave W Building A, Williston, ND 58801, USA",
      "poi_short_description": "Public park with children's facilities, a dog park, maze & direct access to the lake.",
      "poi_long_description": "Public park with children's facilities, a dog park, maze & direct access to the lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-cb5a-768a-b3b4-0c012979ea77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-cb5a-768a-b3b4-0c012979ea77",
        "storage_key": "property/6767906449167191/01a14135-cb5a-768a-b3b4-0c012979ea77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677238210427773620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-lake-park",
      "poi_latitude": "48.2018042",
      "poi_longitude": "-103.618575",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6J6tDJdIVMRtGJiU-F0TIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4de4f893-04be-4f43-987a-d9722fdcd26a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Davidson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11th St W & 9th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "Popular haunt with tennis courts, a playground, a seasonal splash pad & picnic areas.",
      "poi_long_description": "Popular haunt with tennis courts, a playground, a seasonal splash pad & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-d883-776f-bcd9-c21102fd5d8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-d883-776f-bcd9-c21102fd5d8c",
        "storage_key": "property/6767906449167191/01a14135-d883-776f-bcd9-c21102fd5d8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.willistonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469649249667375170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davidson-park",
      "poi_latitude": "48.1560681",
      "poi_longitude": "-103.6406368",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGce3Q4VcIVMRQuDLA7fPyFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bf52aa66-4abc-480d-be91-6ca9f4b12a80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Dakota Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Williston, ND 58801, USA",
      "poi_short_description": "Clean park featuring playgrounds, basketball courts, baseball fields, and a ball diamond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-4a7e-74e4-8bb3-b4c0ec7a08fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-4a7e-74e4-8bb3-b4c0ec7a08fa",
        "storage_key": "property/6767906449167191/01a14137-4a7e-74e4-8bb3-b4c0ec7a08fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.willistonparks.com/dakota-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15992773920822681102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakota-park",
      "poi_latitude": "48.1671024",
      "poi_longitude": "-103.646609",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2Q9yPJcIVMRDl7EyyW_8d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_232062cd-09eb-4bb2-a28e-e50b9fe76fca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Westlawn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-487d-7066-a9ad-53b30267c1ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-487d-7066-a9ad-53b30267c1ee",
        "storage_key": "property/6767906449167191/01a14137-487d-7066-a9ad-53b30267c1ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15099755664669439769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlawn-park",
      "poi_latitude": "48.150739699999995",
      "poi_longitude": "-103.6341245",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-774-9773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c586-7439-9238-b6d38aac7eaa",
        "storage_key": "property/6767906449167191/019d021f-c586-7439-9238-b6d38aac7eaa.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_YZ45xcIVMRGXfQa8YbjdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_462cf396-8c67-4a88-bbca-f21d22658a1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Municipal Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 42nd St W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14135-cffb-77e9-af60-81355532b9d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-cffb-77e9-af60-81355532b9d1",
        "storage_key": "property/6767906449167191/01a14135-cffb-77e9-af60-81355532b9d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.willistonparks.com/williston-municipal-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=4183863530093376763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-municipal-golf-course",
      "poi_latitude": "48.1842994",
      "poi_longitude": "-103.6668777",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 701-577-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c572-7008-8572-a382760e13ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c572-7008-8572-a382760e13ea",
        "storage_key": "property/6767906449167191/019d021f-c572-7008-8572-a382760e13ea.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRYDveNcIVMR-3Ttq7YREDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_6eb01da1-3406-4870-a9a3-7107aaf166ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Basin International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "14127 Jensen Ln, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-49b0-705d-ba4a-e3ed2e23a753.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-49b0-705d-ba4a-e3ed2e23a753",
        "storage_key": "property/6767906449167191/01a14137-49b0-705d-ba4a-e3ed2e23a753.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flywilliston.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7027633441429145880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-basin-international-airport",
      "poi_latitude": "48.257820599999995",
      "poi_longitude": "-103.7417095",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 701-875-8594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c5c3-74af-9b6b-a39fb5afd83f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c5c3-74af-9b6b-a39fb5afd83f",
        "storage_key": "property/6767906449167191/019d021f-c5c3-74af-9b6b-a39fb5afd83f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4mULFpnIVMRGEkKiGErh2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a23a253f-956d-46ce-b2e8-bc7e6e238dcd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 S Main St, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-aab5-73b8-9713-a086be480ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-aab5-73b8-9713-a086be480ce0",
        "storage_key": "property/6767906449167191/019d021f-aab5-73b8-9713-a086be480ce0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WTN",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774109292604435739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston",
      "poi_latitude": "48.142851",
      "poi_longitude": "-103.6211029",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c608-719d-9622-7b9309a5c319.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c608-719d-9622-7b9309a5c319",
        "storage_key": "property/6767906449167191/019d021f-c608-719d-9622-7b9309a5c319.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrz7HPmdbIVMRGy2o-DpSqvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_bcb2c386-8109-485e-9a33-ed54bad29cfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Northwest Dakota Public Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "204 1st St E, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-4727-76ac-9e78-8306cd453eea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-4727-76ac-9e78-8306cd453eea",
        "storage_key": "property/6767906449167191/01a14137-4727-76ac-9e78-8306cd453eea.webp",
        "width": 911,
        "height": 326
      },
      "poi_business_url": "https://www.willistonseniors.org/nw-public-transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=14651603312960118691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-dakota-public-transit",
      "poi_latitude": "48.1445932",
      "poi_longitude": "-103.6178303",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-577-6753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwUdOWdbIVMRo5_s6pXzVMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_a5539cfc-95f3-4827-ac79-a82c9502aae7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Avis Car Rental",
      "poi_type": "Transportation & Transit",
      "poi_address": "14127 Jensen Ln, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-4758-775e-b0c9-aa97c12d6554.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-4758-775e-b0c9-aa97c12d6554",
        "storage_key": "property/6767906449167191/01a14137-4758-775e-b0c9-aa97c12d6554.webp",
        "width": 1120,
        "height": 630
      },
      "poi_business_url": "https://www.avis.com/en/locations/nam/us/nd/williston/xwa?utm_source=google&utm_medium=gbp&utm_campaign=avis_gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17577338011523783041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avis-car-rental",
      "poi_latitude": "48.2581643",
      "poi_longitude": "-103.7417629",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 701-875-4813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5b64-75e2-8ab6-4a6c62c7d273.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14137-5b64-75e2-8ab6-4a6c62c7d273",
        "storage_key": "property/6767906449167191/01a14137-5b64-75e2-8ab6-4a6c62c7d273.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4enTXRnIVMRgZnY8co_7_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_83cdb0e9-f5d0-4232-b188-8f6016f106c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22 E Broadway, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.willistonnd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11702532575506075579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-city-hall",
      "poi_latitude": "48.146412",
      "poi_longitude": "-103.6205041",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 701-577-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c9ed-7063-aed6-db5d22572ade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c9ed-7063-aed6-db5d22572ade",
        "storage_key": "property/6767906449167191/019d021f-c9ed-7063-aed6-db5d22572ade.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWkLhWBbIVMRuw9671-_Z6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_7aa8c062-2b7e-43d7-b4d0-d54ae4fe3a7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williams County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "205 E Broadway, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-4d30-77b7-b711-d7f42f0b100c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-4d30-77b7-b711-d7f42f0b100c",
        "storage_key": "property/6767906449167191/01a14137-4d30-77b7-b711-d7f42f0b100c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.williamsnd.com/locations/williams-county-courthouse/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18398654889358586410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williams-county-courthouse",
      "poi_latitude": "48.1469335",
      "poi_longitude": "-103.6182382",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c9ed-7063-aed6-db5d22572ade.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c9ed-7063-aed6-db5d22572ade",
        "storage_key": "property/6767906449167191/019d021f-c9ed-7063-aed6-db5d22572ade.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNT5FT15bIVMRKvI4QSQnVf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_a4464d1b-b3bc-46fa-bc17-560bc12163a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Williston Basin School District #7 (WBSD#7)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "820 E Broadway, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-af58-724f-bdd2-54e8ee32e4e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-af58-724f-bdd2-54e8ee32e4e1",
        "storage_key": "property/6767906449167191/019d021f-af58-724f-bdd2-54e8ee32e4e1.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "http://willistonschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18359356645665872171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williston-basin-school-district-7-wbsd7",
      "poi_latitude": "48.14654710000001",
      "poi_longitude": "-103.6092071",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 701-572-1580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c16e-7027-bf40-2a8547a82b58",
        "storage_key": "property/6767906449167191/019d021f-c16e-7027-bf40-2a8547a82b58.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN_sVApBcIVMRKxmf4ZiJyf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df83b877-9e92-4b76-8ba0-c5de5f8c7f74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Halliburton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "826 48th Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-53ea-768c-a4d2-9d4c58260a09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-53ea-768c-a4d2-9d4c58260a09",
        "storage_key": "property/6767906449167191/01a14137-53ea-768c-a4d2-9d4c58260a09.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.halliburton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2452822825124163853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halliburton",
      "poi_latitude": "48.1529533",
      "poi_longitude": "-103.6900092",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 701-774-3963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTUfigVcIVMRDfF-JF0tCiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b63a0867-d601-4087-83ca-99205a707d9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Nabors Drilling USA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5131 141st Ave NW, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-51e7-701a-9b7d-daceb6e4a81e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-51e7-701a-9b7d-daceb6e4a81e",
        "storage_key": "property/6767906449167191/01a14137-51e7-701a-9b7d-daceb6e4a81e.webp",
        "width": 807,
        "height": 1280
      },
      "poi_business_url": "http://www.nabors.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10466770438444707708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nabors-drilling-usa",
      "poi_latitude": "48.159030699999995",
      "poi_longitude": "-103.7343524",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 701-264-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD21Qy-peIVMRfG8OKUJwQZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_58d9991f-edfb-4877-8ce5-d91a97bac100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "McKenzie Health - Williston Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "3 4th St E, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-52c7-74e9-a596-21451582b484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-52c7-74e9-a596-21451582b484",
        "storage_key": "property/6767906449167191/01a14137-52c7-74e9-a596-21451582b484.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mckenziehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14417491793030975830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckenzie-health---williston-downtown",
      "poi_latitude": "48.147724",
      "poi_longitude": "-103.621732",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 701-577-6337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-c234-7579-b8f5-1c53b0250aef",
        "storage_key": "property/6767906449167191/019d021f-c234-7579-b8f5-1c53b0250aef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6UuSemBbIVMRVpG4C2Y4Fcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_01c31425-842d-4125-bb5d-0aaba2eb22f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "custom",
      "poi_name": "Bethel Lutheran Home",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1515 2nd Ave W, Williston, ND 58801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/01a14137-5112-7458-b0d4-638179e8af3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-5112-7458-b0d4-638179e8af3b",
        "storage_key": "property/6767906449167191/01a14137-5112-7458-b0d4-638179e8af3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.blnrc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10152359248839569394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethel-lutheran-home",
      "poi_latitude": "48.1592989",
      "poi_longitude": "-103.6273888",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 701-572-6766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ba34-76ac-bf84-82100843e228",
        "storage_key": "property/6767906449167191/019d021f-ba34-76ac-bf84-82100843e228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYPrraJcIVMR8u87g_Js5Iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9e24bd8f8d89474795ac83e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_141b2a68606942cc3c62fb75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_608929f4d321eb18a7e11b26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6d2b587dc8b5dbe137206566",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_2b94842854d1917c7152df18",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d00d411c97a9dfe56bda7210",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "rating": "5",
      "name": "Michael Gilman",
      "text": "Lived there for over a year, about  3 months of living there, a enegetic young Manager named Melissa.\nRight Away all the tenants that comply with Apt. Living Life rules, fell in love with Her❤️\nIn the 1st week we saw an improvement of clean property common areas. A crack down on people leaving yrash any where.\nNeedless to say, the Non-Compliment folks started to comply!",
      "date": "2025-10-25",
      "title": "false"
    },
    {
      "id": "ec_f976b454ebe84dbf6c8f2c83",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "rating": "5",
      "name": "Frank gonzalez",
      "text": "Wow so I have searched and searched for the perfect place to live for the last 5 months and I have found it. Upon moving in we met some really amazing neighbors who cooked for us and helped us move this was so exciting. I am so excited and honored to have a wonderful team in the managers office helping me out with my every need. Katie and Lizzy are super awesome they have walked me through my building and have answered all my questions without fail. I am so super pleased with my decision and I know I will be living here for years to come. Thank you Katie you’re an awesome manager and thank you Lizzy for always having my back and calling me when you say you will. That’s huge trust me. Great team.\nSincerely the Gonzalez Family",
      "date": "2023-07-10",
      "title": "false"
    },
    {
      "id": "ec_89a54ef4be0d98fcdecdc2fb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "rating": "5",
      "name": "Stacy Sanders",
      "text": "Melissa and Bryn make life here at Confluence so much brighter ✨🤩. My family and I are grateful for your hard work and dedication, thank you very much!!!",
      "date": "2025-10-02",
      "title": "false"
    },
    {
      "id": "ec_d891bac34591581d4ce77bb9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "rating": "5",
      "name": "Mary Baldwin",
      "text": "Let me just say how amazing Blake the leasing professional is!! I knew Blake from his time at another complex and when my sister was looking for a place recently he was there to help 100%!!! He answered all of our questions and is an all around outgoing and very caring individual who makes sure to take care of his residents and his potential future residents! 10/10 recommend living anywhere Blake has anything to do with!",
      "date": "2024-11-01",
      "title": "false"
    },
    {
      "id": "ec_8c5b18641e2dc994f7f6ac1b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "rating": "5",
      "name": "Alexis Steinhausen",
      "text": "Blake is the best there is plain and simple. Professional, personable, and timely! He is the reason we stayed with confluence, and are so thankful he found us a smaller unit in such a timely manner per request! I could go on and on about him, how beautiful the apartment is and how happy we are to continue living at the confluence! Highly recommend!!!",
      "date": "2024-12-14",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_e0e3478a361e2bbdf21a76d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "2512184",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_2a8979679328bece86a85b9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "yardi",
      "external_id": "2512183",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 50,
      "deposit": 250,
      "fee": 250,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d2a-cbac-70dc-89cb-a48029b9f53f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Confluence at Harvest Hills Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-in-unit-laundry-williston",
      "search_query": "apartments with in-unit laundry Williston ND",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover our apartments with in-unit laundry in Williston, ND. Enjoy the convenience of laundry at home at Confluence at Harvest Hills.",
      "page_copy": "Experience the ease of living at Confluence at Harvest Hills, where our apartments with in-unit laundry in Williston, ND, redefine convenience. No more trips to the laundromat; you can take care of laundry right at home, freeing up more of your precious time. Our community is designed to make your life easier and more enjoyable.\n\nIn addition to in-unit laundry, residents at Confluence benefit from various exceptional amenities. Large closets offer ample storage space, while the outdoor BBQ grilling area is perfect for gathering with friends. Enjoy peace of mind with on-site management, and meet your furry friends' needs with convenient pet-stations. With plenty of on-site parking, your experience at Confluence is designed to be seamless.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Williston, ND",
      "seo_description": "Explore Williston ND living at its best with Confluence's apartments featuring in-unit laundry and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-pet-friendly-smoke-free-apartments-58801",
      "search_query": "pet-friendly apartments with smoke-free environment 58801",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Smoke-Free Apartments",
      "h2_subtitle": "Find pet-friendly apartments with a smoke-free environment in the 58801 area. Confluence at Harvest Hills prioritizes your lifestyle and comfort.",
      "page_copy": "Welcome to Confluence at Harvest Hills, where we offer pet-friendly apartments with a smoke-free environment, tailored to enhance your living experience in the 58801 area. Our community prioritizes the health and comfort of our residents by providing a clean and welcoming atmosphere for you and your furry companions.\n\nBeyond our pet-friendly and smoke-free policies, Confluence provides amenities that ensure a convenient and pleasant living experience. Enjoy the luxury of large closets, perfect for all your storage needs, and take advantage of our outdoor BBQ grilling area for social gatherings. Our on-site management is dedicated to providing exceptional service, while pet-stations and ample on-site parking add to the convenience of life at Confluence.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Smoke-Free Apartments - Williston 58801",
      "seo_description": "Discover pet-friendly smoke-free apartments in Williston ND 58801 at Confluence. Enjoy comfort with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-energy-efficient-balcony-apartments",
      "search_query": "energy efficient apartments with balcony Williams County",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments with Balcony",
      "h2_subtitle": "Explore energy efficient apartments with balconies in Williams County. Confluence at Harvest Hills offers sustainable living with style.",
      "page_copy": "Confluence at Harvest Hills invites you to experience energy efficient apartments with balconies, nestled in the heart of Williams County. Our thoughtfully designed residences not only prioritize environmental sustainability but also provide a serene outdoor space through private balconies where you can unwind and enjoy the view.\n\nLiving at Confluence means embracing a comfortable, eco-friendly lifestyle. Alongside energy efficiency, our apartments feature large closets for ample storage, and indulgent community amenities, including an outdoor BBQ grilling area and on-site management, all contributing to a unique living experience. With pet-stations and ample on-site parking, life at Confluence is accommodating and convenient.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apts with Balcony in Williams County",
      "seo_description": "Find energy efficient apartments with balconies in Williams County at Confluence, offering style and sustainability.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-ample-parking-management",
      "search_query": "apartments with ample parking and on-site management Williston",
      "category": "Amenity",
      "h1_title": "Apartments with Ample Parking & Management",
      "h2_subtitle": "Discover apartments in Williston with ample parking and on-site management. Confluence at Harvest Hills ensures a stress-free living experience.",
      "page_copy": "At Confluence at Harvest Hills, we provide apartments with ample parking and dedicated on-site management, right here in Williston. Our community is designed to offer you peace of mind and convenience, so you can focus on what truly matters - enjoying your everyday life.\n\nWith benefits like large closets for all your storage needs and an inviting outdoor BBQ grilling area, Confluence ensures every detail enhances your living experience. Our pet-friendly environment and strategically placed pet-stations add to our commitment to making life easier for you and your furry companions. Embrace a community that values comfort and efficiency, keeping your needs at the forefront.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Ample Parking & Management in Williston",
      "seo_description": "Explore Confluence in Williston for apartments with ample parking and on-site management, ensuring a seamless lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-modern-apartments-large-closets-deep-sinks",
      "search_query": "modern apartments with large closets and deep sinks near Prairie Commons",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Large Closets & Sinks",
      "h2_subtitle": "Explore modern apartments near Prairie Commons featuring large closets and deep sinks. Confluence at Harvest Hills offers premium living spaces.",
      "page_copy": "Welcome to Confluence at Harvest Hills, where modern apartments await near Prairie Commons. Our residences come equipped with large closets and deep sinks, offering both style and functionality for today's discerning renters.\n\nSituated in a prime location, Confluence provides more than just modern interiors. Our community features ample on-site parking, convenient pet-stations, and the inviting outdoor BBQ grilling area, perfect for socializing. Our on-site management team ensures all your needs are promptly met, making this the ideal place for anyone seeking comfort and convenience in a vibrant setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Closets & Sinks Near Prairie Commons",
      "seo_description": "Find modern apartments near Prairie Commons with large closets and deep sinks at Confluence, offering refined living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-one-bedroom-apartment-williston-nd",
      "search_query": "one bedroom apartment Williston ND",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Williston, ND",
      "h2_subtitle": "Discover comfortable one bedroom apartments at Confluence in Williston, ND. Enjoy modern amenities and a welcoming community.",
      "page_copy": "Located in the heart of Williston, ND, Confluence at Harvest Hills offers cozy one bedroom apartments designed to complement your lifestyle. Our spacious layouts feature contemporary touches, making them the ideal haven for relaxation and personal expression.\n\nBeyond the doorstep, engage in community amenities like the outdoor BBQ grilling area and enjoy ample on-site parking, ensuring ease and leisure. Our on-site management team is always ready to assist, providing a seamless living experience. Choose Confluence for a blend of comfort, convenience, and community right here in Williston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartment in Williston, ND",
      "seo_description": "Explore Confluence's one bedroom apartments in Williston, ND, offering modern amenities in a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-two-bedroom-apartments-williams-county",
      "search_query": "two bedroom apartments Williams County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Williams County",
      "h2_subtitle": "Explore spacious two bedroom apartments at Confluence in Williams County. Enjoy modern living with welcoming community features.",
      "page_copy": "Confluence at Harvest Hills proudly offers two bedroom apartments in the heart of Williams County, perfect for those seeking ample room and comfort. Our thoughtfully designed spaces provide the ideal setting for families or roommates to create a home.\n\nBeyond the spacious interiors, Confluence residents benefit from community amenities such as a welcoming outdoor BBQ grilling area and plentiful on-site parking. With attentive on-site management, we strive to deliver a carefree living experience. Located conveniently in Williston, ND, Confluence combines convenience with quality in a vibrant community setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Williams County",
      "seo_description": "Discover spacious two bedroom apartments at Confluence in Williams County, with modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-three-bedroom-apartments-near-58801",
      "search_query": "three bedroom apartments near 58801",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 58801",
      "h2_subtitle": "Find spacious three bedroom apartments near the 58801 area at Confluence, offering modern amenities and a vibrant community setting.",
      "page_copy": "Discover the ideal space for families and roommates alike with our three bedroom apartments near 58801 at Confluence at Harvest Hills. Designed for comfort and functionality, these apartments provide generous living areas, ensuring every resident has ample space to thrive.\n\nLocated conveniently close to local amenities, Confluence offers the perfect blend of modern living and communal facilities. Enjoy features like the outdoor BBQ grilling area and ample on-site parking. With professional on-site management, our community is dedicated to offering a stress-free living experience for everyone.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 58801",
      "seo_description": "Explore spacious three bedroom apartments near 58801 at Confluence, featuring modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-near-williston-state-college-nd",
      "search_query": "apartments near Williston State College ND",
      "category": "School",
      "h1_title": "Apartments Near Williston State College ND",
      "h2_subtitle": "Discover comfortable living close to Williston State College, ND, at Confluence. Ideal for students and professionals alike.",
      "page_copy": "Confluence at Harvest Hills offers the perfect location for students and professionals searching for apartments near Williston State College, ND. Our community features modern living spaces designed to accommodate a busy lifestyle while offering a quiet retreat from daily stresses.\n\nBenefit from living in a vibrant community with amenities like an outdoor BBQ grilling area and convenient on-site management. With ample on-site parking and pet stations, Confluence ensures a hassle-free experience just a short distance from the college. Join a welcoming community that combines both convenience and comfort in Williston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Williston State College ND",
      "seo_description": "Find ideal apartments near Williston State College, ND, at Confluence. Enjoy modern living and community amenities perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-near-chi-st-alexius-health-williston-medical-center",
      "search_query": "apartments near CHI St. Alexius Health Williston Medical Center ND",
      "category": "Hospital",
      "h1_title": "Apartments Near CHI St. Alexius Health Williston",
      "h2_subtitle": "Live in comfort with Confluence, conveniently located near CHI St. Alexius Health Williston Medical Center ND. Ideal for medical professionals.",
      "page_copy": "Confluence at Harvest Hills offers ideally situated apartments for those needing proximity to CHI St. Alexius Health Williston Medical Center, ND. Whether you're a healthcare professional or seeking easy access to medical facilities, our community provides the perfect location.\n\nEnjoy spacious living with amenities designed for convenience, such as ample on-site parking and an outdoor BBQ grilling area. Our on-site management team ensures a seamless living experience. Experience a community where comfort meets accessibility, right in the heart of Williston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near CHI St. Alexius Health Williston",
      "seo_description": "Find convenient apartments near CHI St. Alexius Health Williston Medical Center at Confluence, perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-near-spring-lake-park-williston",
      "search_query": "apartments near spring lake park williston",
      "category": "Park",
      "h1_title": "Apartments Near Spring Lake Park Williston",
      "h2_subtitle": "Experience the charm of living near Spring Lake Park in Williston at Confluence. Enjoy modern amenities in a peaceful park-side setting.",
      "page_copy": "Nestled near the serene beauty of Spring Lake Park, Confluence at Harvest Hills offers apartments that perfectly balance convenience and tranquility. Residents enjoy immediate access to the lush green spaces and recreational activities available at the park, making it an ideal location for nature enthusiasts and families.\n\nBeyond the great location, our community provides numerous amenities like outdoor BBQ grilling areas and pet stations, which cater to a fun and comfortable lifestyle. Ample on-site parking and professional on-site management add to the ease and quality of living here. Discover park-side living with all the modern comforts you desire in Williston.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Spring Lake Park Williston",
      "seo_description": "Live near Spring Lake Park in Williston at Confluence, where modern amenities meet natural beauty and easy access to outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-close-to-davidson-park-north-dakota",
      "search_query": "apartments close to davidson park in north dakota",
      "category": "Park",
      "h1_title": "Apartments Close to Davidson Park, ND",
      "h2_subtitle": "Enjoy living close to Davidson Park in North Dakota at Confluence, a community offering modern amenities and a friendly atmosphere.",
      "page_copy": "Confluence at Harvest Hills is your ideal destination for apartments close to Davidson Park in North Dakota. Our community's proximity to the park makes it a haven for those who love outdoor activities, whether it's a casual stroll, a family picnic, or enjoying the beautiful landscapes.\n\nResidents at Confluence benefit from spacious living spaces and amenities including an outdoor BBQ grilling area, large closets, and ample on-site parking. With on-site management and pet-friendly policies featuring convenient pet stations, Confluence ensures all your needs are met in a vibrant community setting right near one of North Dakota's beloved parks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Davidson Park, ND",
      "seo_description": "Discover apartments close to Davidson Park, ND, at Confluence. Enjoy modern living with convenient amenities and park-side pleasure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167191",
      "source": "generator",
      "page_item_url": "confluence-apartments-by-western-star-complex-williams-county",
      "search_query": "apartments by western star complex williams county",
      "category": "Park",
      "h1_title": "Apartments by Western Star Complex",
      "h2_subtitle": "Find your perfect home at Confluence, located by the Western Star Complex in Williams County. Experience convenience and quality living here.",
      "page_copy": "Situated by the Western Star Complex in Williams County, Confluence at Harvest Hills offers exceptional apartments that cater to those seeking both convenience and modern amenities. Our location is perfect for anyone looking to enjoy the dynamic events and opportunities available at the Western Star Complex.\n\nResidents benefit from features such as large closets, ample on-site parking, and a welcoming outdoor BBQ grilling area. Our on-site management team is dedicated to providing a seamless living experience, while pet stations add convenience for pet owners. Embrace the vibrant community and effortless lifestyle awaiting you at Confluence.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Western Star Complex",
      "seo_description": "Explore apartments by Western Star Complex in Williams County at Confluence, offering convenience and modern amenities for a great lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309502555"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7012046936"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MNH9PPNP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "d2f4dadd-a651-42e6-b75e-c941eca32a86"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/09752982-7ee4-4953-80fe-1bdcf0ffe023/app.js?property=09752982-7ee4-4953-80fe-1bdcf0ffe023&propertyName=Confluence+at+Harvest+Hills&channelUuid=c248efb5-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47755006836"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InRoVGdMTzRmN1JRSFluTHlLU1BoK0E9PSIsInZhbHVlIjoicTRKaDhkNWlNajJRMTE3SkRqNkRjZz09IiwibWFjIjoiNDAwNmM2NWFlMzZmMzZiYzAwMTY2YmE1MGM1ZThhMTQyYzQ0NjY3ZGE2YTQ0ZThiNjMyNjA0N2FhZjQxYWE2OSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309502555",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7012046936",
  "custom_google_gtm_id": "GTM-MNH9PPNP",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "d2f4dadd-a651-42e6-b75e-c941eca32a86",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/09752982-7ee4-4953-80fe-1bdcf0ffe023/app.js?property=09752982-7ee4-4953-80fe-1bdcf0ffe023&propertyName=Confluence+at+Harvest+Hills&channelUuid=c248efb5-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47755006836",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InRoVGdMTzRmN1JRSFluTHlLU1BoK0E9PSIsInZhbHVlIjoicTRKaDhkNWlNajJRMTE3SkRqNkRjZz09IiwibWFjIjoiNDAwNmM2NWFlMzZmMzZiYzAwMTY2YmE1MGM1ZThhMTQyYzQ0NjY3ZGE2YTQ0ZThiNjMyNjA0N2FhZjQxYWE2OSJ9",
  "custom_audioeye_site_id": "f7ad7fe7-1288-4ead-8746-cd0fe06884ad",
  "custom_audioeye_site_hash": "59df04271eab5acd74b88e8f62b3d86b"
};

export const generatedAt = '2026-11-04T23:48:25.245Z';
